import { Field } from "@progress/kendo-react-form";
import type { KeyValue } from "@progress/kendo-react-form";
import {
  currencyCodeValidator,
  notEmptyValidator,
  positionValidator,
} from "@iliotech/data-wire";
import * as React from "react";
import { Autocomplete, AutocompleteProps } from "../Autocomplete/Autocomplete";
interface IOwnProps extends Omit<AutocompleteProps, "name" | "label"> {
  errors: KeyValue<string>;
  name?: string;
  label?: string | null;
  positions?: any;
}

export const PositionSearchField = ({
  errors,
  name = "position",
  label = "Name",
  positions,
  ...rest
}: IOwnProps) => {
  // console.log({ positions })
  return (
    <Field
      component={Autocomplete}
      label={label}
      name={name}
      dataItemKey={"name"}
      textField={"name"}
      placeholder={"Enter name"}
      error={errors?.[name]}
      filterData={(filter: string) => {
        // console.log({positions})
        return positions
          ?.filter(
            (item: any) =>
              item.currencyCode
                .toLowerCase()
                .startsWith(filter.toLowerCase()) ||
              item.label.toLowerCase().startsWith(filter.toLowerCase())
          )
          ?.map((pos: any) => ({
            ...pos,
            name: `${pos.label} [${pos.currencyCode} - ${pos.currencySymbol}]`,
          }));
      }}
      validator={currencyCodeValidator}
      data={positions}
      allowCustom
    />
  );
};
